import { ReactNode } from "react";
import { useAuth } from "@/features/auth/model/AuthContext";
import { Navigate } from "react-router-dom";
import { isCreator, UserRole } from "@/shared/types/roles";

interface CreatorRouteProps {
  children: ReactNode;
  redirectTo?: string;
}

/** Rotas do Creator Financial: creators (PHOTOGRAPHER, INFLUENCER) e ADMIN. */
export function CreatorRoute({
  children,
  redirectTo = "/unauthorized",
}: CreatorRouteProps) {
  const { user, loading, isAuthenticated } = useAuth();
  const role = user?.role ?? null;

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#1A1A1A] text-white">
        Carregando...
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/auth" replace />;
  }

  const canAccessCreatorFinancial =
    role && (isCreator(role) || role === UserRole.ADMIN);
  if (!canAccessCreatorFinancial) {
    return <Navigate to={redirectTo} replace />;
  }

  return <>{children}</>;
}
